import {
  IESDPCaptainReportsDay,
  IESDPCaptainReportsStudent,
  IESDPTeamIterationStudents,
  IESDPTeams,
  IESDPTeamUser,
} from '@interfaces/IESDP';
import { IUsersPagination } from '@interfaces/IUser';
import {
  IESDPViewState,
  initialsESDPViewState,
} from '@myStore/ESDP-view/ESDP-view.state';
import {
  EESDPViewActions,
  ESDPViewActions,
} from '@myStore/ESDP-view/ESDP.view.actions';

export const ESDPViewReducers = (
  state = initialsESDPViewState,
  actions: ESDPViewActions
): IESDPViewState => {
  switch (actions.type) {
    case EESDPViewActions.GetTeamRequest: {
      return { ...state, team: { ...state.team, isLoading: true } };
    }
    case EESDPViewActions.GetTeamSuccess: {
      return {
        ...state,
        team: { ...state.team, data: actions.payload, isLoading: false },
      };
    }
    case EESDPViewActions.GetTeamFailure: {
      return { ...state, team: { ...state.team, isLoading: false } };
    }
    case EESDPViewActions.ClearGetTeam: {
      return { ...state, team: { ...state.team, data: null } };
    }

    case EESDPViewActions.GetTeamsRequest:
      return { ...state, isLoading: true };
    case EESDPViewActions.GetTeamsSuccess:
      return { ...state, isLoading: false, groupTeams: actions.payload };
    case EESDPViewActions.GetTeamsFailure:
      return { ...state, isLoading: false, errors: actions.errors };
    case EESDPViewActions.ClearGetTeams:
      return { ...state, isLoading: false, groupTeams: null, errors: null };

    //GenerateESDPTeam
    case EESDPViewActions.GenerateESDPTeamsRequest:
      return { ...state, isLoading: true };
    case EESDPViewActions.GenerateESDPTeamsSuccess:
      return { ...state, isLoading: false, data: actions.payload };
    case EESDPViewActions.GenerateESDPTeamsFailure:
      return { ...state, isLoading: false, errors: actions.errors };
    case EESDPViewActions.ClearGenerateESDPTeams:
      return { ...state, isLoading: false, data: [], errors: null };

    case EESDPViewActions.ChangeGeneratedESDPTeams:
      return {
        ...state,
        data: changeTeams(
          state.data,
          actions.user,
          actions.dropIndex,
          actions.dragIndex
        ),
      };

    //GetFreeTimeGraph
    case EESDPViewActions.GetFreeTimeGraphRequest:
      return { ...state, isLoading: true };
    case EESDPViewActions.GetFreeTimeGraphSuccess:
      return { ...state, isLoading: false, freeTimeData: actions.data };
    case EESDPViewActions.GetFreeTimeGraphFailure:
      return { ...state, isLoading: false, errors: actions.errors };
    case EESDPViewActions.ClearGetFreeTimeGraph:
      return { ...state, isLoading: false, data: [] };

    case EESDPViewActions.GetIterationsRequest:
      return { ...state, iterations: { ...state.iterations, isLoading: true } };
    case EESDPViewActions.GetIterationsSuccess:
      return {
        ...state,
        iterations: {
          ...state.iterations,
          data: [...actions.payload, ...state.iterations.data],
          isLoading: false,
        },
      };
    case EESDPViewActions.ClearGetIterations:
      return {
        ...state,
        iterations: {
          ...state.iterations,
          data: [],
          isLoading: false,
        },
      };

    case EESDPViewActions.GetIterationByIdRequest:
      return { ...state, iterations: { ...state.iterations, isLoading: true } };
    case EESDPViewActions.GetIterationByIdSuccess:
      return {
        ...state,
        iterations: {
          ...state.iterations,
          currentIteration: actions.payload,
          isLoading: false,
        },
      };
    case EESDPViewActions.ClearGetIterationById:
      return {
        ...state,
        iterations: {
          ...state.iterations,
          currentIteration: null,
          isLoading: false,
        },
      };

    case EESDPViewActions.GetIterationReviewByIdRequest:
      return { ...state, iterations: { ...state.iterations, isLoading: true } };
    case EESDPViewActions.GetIterationReviewByIdSuccess:
      return {
        ...state,
        iterations: {
          ...state.iterations,
          review: actions.payload,
          isLoading: false,
        },
      };
    case EESDPViewActions.GetIterationReviewByIdFailure:
      return {
        ...state,
        iterations: {
          ...state.iterations,
          isLoading: false,
        },
      };
    case EESDPViewActions.ClearGetIterationReviewById:
      return {
        ...state,
        iterations: {
          ...state.iterations,
          review: null,
          isLoading: false,
        },
      };

    case EESDPViewActions.GetTeamStudentsRequest:
      return {
        ...state,
        students: { ...state.students, isLoading: true },
      };
    case EESDPViewActions.GetTeamStudentsSuccess:
      return {
        ...state,
        students: {
          ...state.students,
          data: actions.payload,
          isLoading: false,
        },
      };
    case EESDPViewActions.GetTeamStudentsFailure:
      return {
        ...state,
        students: { ...state.students, isLoading: false },
      };
    case EESDPViewActions.ClearGetTeamStudents:
      return {
        ...state,
        students: { ...state.students, data: null, isLoading: false },
      };

    case EESDPViewActions.GetTeamMentorsRequest:
      return {
        ...state,
        mentors: { ...state.mentors, isLoading: true },
      };
    case EESDPViewActions.GetTeamMentorsSuccess:
      return {
        ...state,
        mentors: {
          ...state.mentors,
          data: actions.payload,
          isLoading: false,
        },
      };
    case EESDPViewActions.GetTeamMentorsFailure:
      return {
        ...state,
        mentors: { ...state.mentors, isLoading: false },
      };
    case EESDPViewActions.ClearGetTeamMentors:
      return {
        ...state,
        mentors: { ...state.mentors, data: null, isLoading: false },
      };

    case EESDPViewActions.GetIterationCaptainReportsRequest:
      return {
        ...state,
        iterationCaptainReports: {
          ...state.iterationCaptainReports,
          isLoading: true,
        },
      };
    case EESDPViewActions.GetIterationCaptainReportsSuccess:
      return {
        ...state,
        iterationCaptainReports: {
          ...state.iterationCaptainReports,
          data: actions.payload,
          isLoading: false,
        },
      };
    case EESDPViewActions.GetIterationCaptainReportsFailure:
      return {
        ...state,
        iterationCaptainReports: {
          ...state.iterationCaptainReports,
          isLoading: false,
        },
      };
    case EESDPViewActions.ClearGetIterationCaptainReports:
      return {
        ...state,
        iterationCaptainReports: {
          ...state.iterationCaptainReports,
          data: null,
          isLoading: false,
        },
      };

    case EESDPViewActions.SetCurrentIteration:
      return {
        ...state,
        iterations: { ...state.iterations, currentIteration: actions.payload },
      };
    case EESDPViewActions.ClearCurrentIteration:
      return {
        ...state,
        iterations: { ...state.iterations, currentIteration: null },
      };

    case EESDPViewActions.UpdateIteration:
      return {
        ...state,
        iterations: {
          ...state.iterations,
          data: state.iterations.data.map(iteration => {
            if (iteration.id === actions.payload.id) {
              return actions.payload;
            }

            return iteration;
          }),
        },
      };

    case EESDPViewActions.DeleteIteration:
      return {
        ...state,
        iterations: {
          ...state.iterations,
          data: state.iterations.data.filter(
            iteration => iteration.id !== actions.payload
          ),
        },
      };

    case EESDPViewActions.AddIteration:
      return {
        ...state,
        iterations: {
          ...state.iterations,
          data: [actions.payload, ...state.iterations.data],
        },
      };

    case EESDPViewActions.DeleteStudentFromTeam:
      return {
        ...state,
        students: {
          ...state.students,
          data: deleteStudent(state.students.data, actions.studentId),
        },
      };

    case EESDPViewActions.GetTeamDocumentsRequest:
      return {
        ...state,
        documents: {
          ...state.documents,
          isLoading: true,
        },
      };
    case EESDPViewActions.GetTeamDocumentsSuccess:
      return {
        ...state,
        documents: {
          ...state.documents,
          data: actions.documents,
          isLoading: false,
        },
      };
    case EESDPViewActions.GetTeamDocumentsFailure:
      return {
        ...state,
        documents: {
          ...state.documents,
          isLoading: false,
        },
        errors: actions.errors,
      };
    case EESDPViewActions.ClearGetTeamDocuments:
      return {
        ...state,
        documents: {
          ...state.documents,
          data: null,
          isLoading: false,
        },
        errors: null,
      };

    case EESDPViewActions.GetTeamDocumentByIdRequest:
      return {
        ...state,
        documents: {
          ...state.documents,
          isLoading: true,
        },
      };
    case EESDPViewActions.GetTeamDocumentByIdSuccess:
      return {
        ...state,
        documents: {
          ...state.documents,
          document: actions.document,
          isLoading: false,
        },
      };
    case EESDPViewActions.GetTeamDocumentByIdFailure:
      return {
        ...state,
        documents: {
          ...state.documents,
          isLoading: false,
        },
        errors: actions.errors,
      };
    case EESDPViewActions.ClearGetTeamDocumentById:
      return {
        ...state,
        documents: {
          ...state.documents,
          document: null,
          isLoading: false,
        },
        errors: null,
      };

    case EESDPViewActions.GetTeamMaterialsRequest:
      return {
        ...state,
        materials: {
          ...state.materials,
          isLoading: true,
        },
      };
    case EESDPViewActions.GetTeamMaterialsSuccess:
      return {
        ...state,
        materials: {
          ...state.materials,
          data: actions.materials,
          isLoading: false,
        },
      };
    case EESDPViewActions.GetTeamMaterialsFailure:
      return {
        ...state,
        materials: {
          ...state.materials,
          isLoading: false,
        },
        errors: actions.errors,
      };
    case EESDPViewActions.ClearGetTeamMaterials:
      return {
        ...state,
        materials: {
          ...state.materials,
          data: [],
          isLoading: false,
        },
        errors: null,
      };

    case EESDPViewActions.UpdateIterationReview:
      return {
        ...state,
        iterations: {
          ...state.iterations,
          review: actions.payload,
        },
      };

    case EESDPViewActions.UpdateIterationStudentsReview:
      return {
        ...state,
        iterations: {
          ...state.iterations,
          currentIteration: state.iterations.currentIteration
            ? {
                ...state.iterations.currentIteration,
                students: changeCurrentIteration(
                  actions.payload.id,
                  state.iterations.currentIteration.students
                ),
              }
            : null,
        },
      };

    case EESDPViewActions.UpdateIterationCaptainReport:
      return {
        ...state,
        iterationCaptainReports: {
          ...state.iterationCaptainReports,
          data: state.iterationCaptainReports.data
            ? {
                ...state.iterationCaptainReports.data,
                work_days: changeCaptainReport(
                  state.iterationCaptainReports.data.work_days,
                  actions.index,
                  actions.payload
                ),
              }
            : null,
        },
      };

    case EESDPViewActions.UpdateIterationStatus:
      return {
        ...state,
        iterations: {
          ...state.iterations,
          currentIteration: state.iterations.currentIteration
            ? {
                ...state.iterations.currentIteration,
                is_active: actions.isActive,
              }
            : null,
        },
      };
    default:
      return state;
  }
};

const changeTeams = (
  teams: IESDPTeams[],
  user: IESDPTeamUser,
  dropIndex: number,
  dragIndex: number
): IESDPTeams[] => {
  return teams.map((teams, index) => {
    if (index === dropIndex) {
      return {
        ...teams,
        team: [...teams.team, user].sort((a, b) => b.score - a.score),
      };
    }

    if (index === dragIndex) {
      return {
        ...teams,
        team: [...teams.team].filter(teamUser => teamUser.id !== user.id),
      };
    }

    return teams;
  });
};

const deleteStudent = (
  teamStudents: IUsersPagination | null,
  studentId: number
): IUsersPagination | null => {
  if (teamStudents) {
    return {
      ...teamStudents,
      results: teamStudents.results.filter(student => student.id !== studentId),
    };
  }

  return null;
};

const changeCurrentIteration = (
  id: number,
  students?: IESDPTeamIterationStudents[]
): IESDPTeamIterationStudents[] | undefined => {
  if (students) {
    return students.map(student => {
      if (student.review.id === id) {
        return {
          ...student,
          review: { ...student.review, is_published: true },
        };
      }

      return student;
    });
  }

  return students;
};

const changeCaptainReport = (
  reports: IESDPCaptainReportsDay[],
  indexDay: number,
  newReport: IESDPCaptainReportsStudent
): IESDPCaptainReportsDay[] => {
  return reports.map((report, index) => {
    if (indexDay === index) {
      return {
        ...report,
        students: report.students.map(oldReport => {
          if (oldReport.id === newReport.id) {
            return newReport;
          }
          return oldReport;
        }),
      };
    }
    return report;
  });
};
